import { authFetch } from "utils";

export const getAll = () =>
  authFetch(`${apiUrl}${version}/users/subscriptions`, {
    method: "GET",
  });

export const saveAll = (
  unsubscribeDeals,
  assetDigestSubscriptions,
  dealDigestSubscriptions,
  portfolioDealSubscriptions
) =>
  authFetch(`${apiUrl}${version}/users/subscriptions`, {
    method: "PUT",
    json: {
      unsubscribeDeals,
      assetDigestSubscriptionsAttributes: assetDigestSubscriptions,
      dealDigestSubscriptionsAttributes: dealDigestSubscriptions,
      portfolioDealSubscriptionsAttributes: portfolioDealSubscriptions,
    },
  });

export const create = (
  assetDigestSubscriptions,
  dealDigestSubscriptions,
  portfolioDealSubscriptions
) =>
  authFetch(`${apiUrl}${version}/users/subscriptions`, {
    method: "POST",
    json: {
      assetDigestSubscriptionsAttributes: assetDigestSubscriptions,
      dealDigestSubscriptionsAttributes: dealDigestSubscriptions,
      portfolioDealSubscriptionsAttributes: portfolioDealSubscriptions,
    },
  });

export const remove = (
  assetDigestSubscriptions,
  dealDigestSubscriptions,
  portfolioDealSubscriptions
) =>
  authFetch(`${apiUrl}${version}/users/subscriptions`, {
    method: "DELETE",
    json: {
      assetDigestSubscriptionsAttributes: assetDigestSubscriptions,
      dealDigestSubscriptionsAttributes: dealDigestSubscriptions,
      portfolioDealSubscriptionsAttributes: portfolioDealSubscriptions,
    },
  });
